export default __webpack_public_path__ + "static/media/evas-QR.2b7146ce.jpg";